import { z } from "zod";
import {
	rgbHexStringToRgbNumber,
	rgbToRgba,
	rgbToLab,
	rgbToHsl,
} from "../utils/colour-conversions.ts";

function zRgbHexString() {
	// TODO: Restrict fully (starting small with startsWith June 2026)
	// TODO: Can have a strong ts type `#${string}`
	return z.string().startsWith("#");
}

type BrickColourRgba = number;
type BrickColourHexString = z.output<ReturnType<typeof zRgbHexString>>;

const brickColourSchema = z
	.object({
		identifier: z.number(),
		symbolSvgContent: z.string().optional(),
		r: z.number(),
		g: z.number(),
		b: z.number(),
		lab: z
			.object({
				l: z.number(),
				a: z.number(),
				b: z.number(),
			})
			.readonly(),
		rgba: z.number().nonnegative().int(),
		isVisuallyDark: z.boolean(),
		hexString: zRgbHexString(),
		// Positive?
		lightness: z.number(),
		// Positive?
		saturation: z.number(),
		// More validation?
		hue: z.number(),
	})
	.readonly();

type BrickColour = z.infer<typeof brickColourSchema>;

type TransportBrickColour = {
	readonly colour: string;
	readonly identifier: number;
	readonly symbolSvgContent?: string;
};

const startMask24 = 0xff0000;
const greenMask24 = 0x00ff00;
const endMask24 = 0x0000ff;

function isRgbVisuallyDark(r: number, g: number, b: number) {
	// const isVisuallyDark = (r + g + b) / 3 < 0xff * 0.5;
	return (r * 299 + g * 587 + b * 114) / 1000 < 150;
}

/* eslint-disable no-bitwise */
function transportBrickColourToCore(
	transport: TransportBrickColour,
): BrickColour {
	const rgb = rgbHexStringToRgbNumber(transport.colour);
	const r = (rgb & startMask24) >> 16;
	const g = (rgb & greenMask24) >> 8;
	const b = rgb & endMask24;
	const hsl = rgbToHsl(r, g, b);
	// This is a rough hack. Assumes uniform visual perception over rgb space
	// which isn't true.
	// TODO: Find proper method
	return {
		identifier: transport.identifier,
		rgba: rgbToRgba(rgb, 0xff),
		r,
		g,
		b,
		isVisuallyDark: isRgbVisuallyDark(r, g, b),
		lab: rgbToLab(r, g, b),
		hexString: transport.colour,
		lightness: hsl.l,
		saturation: hsl.s,
		hue: hsl.h,
	};
}
/* eslint-enable no-bitwise */

export type {
	BrickColourHexString,
	BrickColourRgba,
	TransportBrickColour,
	BrickColour,
};
export { zRgbHexString, brickColourSchema, transportBrickColourToCore };
